module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"language":"English"},"th":{"language":"ภาษาไทย"}}')
  delete Component.options._Ctor
}
